import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Popup from "../../component/Popup";
import RawImage from "./ProductImage";
import ProductsTagsUpdatePopup from "./ProductsTagsUpdatePopup";

const RetailerImages = ({ count, page, setPage, products, updateImages }) => {

  const { userLoggedIn } = useSelector(state => state)
  const [tagspopupMediaId, setTagsPopupMediaId] = useState(null);
  const [allTagsFilled, setAllTagsFilled] = useState(false)
  const [showTagsPopup, setShowTagsPopup] = useState(false);
  const limit = 100;

  useEffect(() => {
    if (showTagsPopup == false) {
      setTagsPopupMediaId(null)
    }
  }, [showTagsPopup])

  const handleShortlist = async (image) => {
    const value = image.shortlisted ? false : true
    const response = await axios.post(`/api/retailer-v2/shortlist/${image.pk}/${value}`)
    if (response.data.success) {
      updateImages(prev => {
        const next = [...prev];
        const currentImage = next.filter(i => i.pk == image.pk)
        if (currentImage && currentImage[0]) {
          currentImage[0].shortlisted = value
        }
        return next;
      })
    }
  }
  useEffect(() => {
    if (tagspopupMediaId != null) setShowTagsPopup(true)
  }, [tagspopupMediaId])

  return <div>
    <div className='flex items-center  justify-end px-20'>
      <div className='mr-2'>{count} Images</div>
      <div>
        <button className='hover:bg-blue-700 text-white disabled:opacity-50 bg-blue-500 px-7 py-1 mr-2 rounded-3xl' disabled={page <= 1} onClick={() => { setPage(prev => prev - 1) }}>prev</button>
        <span className='mr-2'>{page}/{Math.ceil(count / limit)}</span>
        <button className='hover:bg-blue-700 text-white disabled:opacity-50 bg-blue-500 px-7 py-1 rounded-3xl' disabled={page >= Math.ceil(count / limit)} onClick={() => { setPage(prev => prev + 1) }}>next</button>
      </div>
    </div>

    <div className="">
      {products.length > 0 ? <div className="flex flex-wrap">
        {products.map((prod, i) => <RawImage prod={prod} key={prod.pk} curator={userLoggedIn.curator} updateTagsPopupMediaId={setTagsPopupMediaId} handleShortlist={handleShortlist} />)}
      </div>
        : <div className="py-40 flex justify-center"><p>No products found</p></div>}
    </div>

    <Popup isPopUp={showTagsPopup} setIsPopUp={(nState) => {
      if (!nState && allTagsFilled)
        setShowTagsPopup(false)
    }} >

      <ProductsTagsUpdatePopup mediaId={tagspopupMediaId} setAllTagsFilled={setAllTagsFilled} allTagsFilled={allTagsFilled} />
    </Popup>
  </div>
}

export default RetailerImages

